import { configureStore } from "@reduxjs/toolkit";
import endpointsSlice from "./slices/endpointsSlice";
import { apiSlice } from "./slices/apiSlice";
import authSlice from "./slices/authSlice";
import usersSlice from "./slices/usersSlice";
import companiesSlice from "./slices/companiesSlice";
import licensesSlice from "./slices/licensesSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authSlice,
    endpoints: endpointsSlice,
    users: usersSlice,
    companies: companiesSlice,
    licenses: licensesSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
